
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const DatabaseSchema = () => {
  const tables = [
    {
      name: 'users',
      position: { x: 50, y: 50 },
      fields: ['id (PK)', 'username', 'password', 'role', 'name', 'email', 'region', 'isActive', 'inviteToken', 'baseRatePerCampaign', 'volumeDiscountRules', 'paymentNotes'],
      color: '#3B82F6'
    },
    {
      name: 'retailers',
      position: { x: 300, y: 50 },
      fields: ['id (PK)', 'name', 'description', 'logo'],
      color: '#10B981'
    },
    {
      name: 'store_formats',
      position: { x: 550, y: 50 },
      fields: ['id (PK)', 'name', 'description', 'retailerId (FK)'],
      color: '#10B981'
    },
    {
      name: 'stores',
      position: { x: 800, y: 50 },
      fields: ['id (PK)', 'name', 'address', 'phone', 'managerName', 'latitude', 'longitude', 'region', 'retailerId (FK)', 'formatId (FK)', 'operatorId (FK)', 'hasESL'],
      color: '#10B981'
    },
    {
      name: 'campaign_types',
      position: { x: 50, y: 300 },
      fields: ['id (PK)', 'name', 'description', 'color', 'sortOrder', 'isActive', 'isDefault'],
      color: '#F59E0B'
    },
    {
      name: 'campaign_statuses',
      position: { x: 300, y: 300 },
      fields: ['id (PK)', 'name', 'description', 'color', 'sortOrder', 'isActive'],
      color: '#F59E0B'
    },
    {
      name: 'campaigns',
      position: { x: 550, y: 300 },
      fields: ['id (PK)', 'name', 'description', 'statusId (FK)', 'typeId (FK)', 'campaignTypeKey', 'twinOfCampaignId (FK)', 'dueDate', 'cycleId (FK)', 'rateTemplateId (FK)', 'createdBy (FK)'],
      color: '#F59E0B'
    },
    {
      name: 'assignments',
      position: { x: 800, y: 300 },
      fields: ['id (PK)', 'campaignId (FK)', 'storeId (FK)', 'operatorId (FK)', 'status', 'instructions', 'materials', 'location', 'priority', 'estimatedDuration'],
      color: '#EF4444'
    },
    {
      name: 'media_formats',
      position: { x: 50, y: 550 },
      fields: ['id (PK)', 'name', 'description', 'dimensions', 'type', 'quantityType', 'photoUrl'],
      color: '#8B5CF6'
    },
    {
      name: 'tasks',
      position: { x: 300, y: 550 },
      fields: ['id (PK)', 'name', 'description', 'defaultRate', 'campaignTypeId (FK)', 'isActive'],
      color: '#06B6D4'
    },
    {
      name: 'booking_cycles',
      position: { x: 550, y: 550 },
      fields: ['id (PK)', 'retailerId (FK)', 'name', 'startDate', 'endDate', 'bookingDeadline', 'status', 'description'],
      color: '#84CC16'
    },
    {
      name: 'packs',
      position: { x: 800, y: 550 },
      fields: ['id (PK)', 'name', 'description', 'retailerId (FK)', 'isActive'],
      color: '#F97316'
    },
    {
      name: 'proofs',
      position: { x: 1050, y: 300 },
      fields: ['id (PK)', 'assignmentId (FK)', 'photoUrls', 'signatureUrl', 'latitude', 'longitude', 'notes'],
      color: '#EF4444'
    },
    {
      name: 'issues',
      position: { x: 1300, y: 300 },
      fields: ['id (PK)', 'assignmentId (FK)', 'description', 'status', 'reportedBy (FK)'],
      color: '#EF4444'
    },
    {
      name: 'rate_templates',
      position: { x: 50, y: 800 },
      fields: ['id (PK)', 'name', 'description', 'retailerId (FK)', 'templateData', 'isDefault', 'createdBy (FK)'],
      color: '#EC4899'
    },
    {
      name: 'operator_task_rates',
      position: { x: 300, y: 800 },
      fields: ['id (PK)', 'operatorId (FK)', 'taskId (FK)', 'rate', 'effectiveDate', 'endDate', 'isActive'],
      color: '#EC4899'
    },
    {
      name: 'payment_records',
      position: { x: 550, y: 800 },
      fields: ['id (PK)', 'operatorId (FK)', 'assignmentId (FK)', 'campaignId (FK)', 'storeId (FK)', 'paymentType', 'amount', 'status'],
      color: '#14B8A6'
    },
    {
      name: 'campaign_retailers',
      position: { x: 800, y: 800 },
      fields: ['id (PK)', 'campaignId (FK)', 'retailerId (FK)'],
      color: '#F59E0B'
    },
    {
      name: 'campaign_stores',
      position: { x: 1050, y: 800 },
      fields: ['id (PK)', 'campaignId (FK)', 'storeId (FK)', 'packId (FK)', 'packSource', 'selectionType'],
      color: '#F59E0B'
    },
    {
      name: 'campaign_media',
      position: { x: 1300, y: 800 },
      fields: ['id (PK)', 'campaignId (FK)', 'mediaFormatId (FK)', 'quantity'],
      color: '#F59E0B'
    }
  ];

  const relationships = [
    { from: 'users', to: 'stores', label: 'operatorId' },
    { from: 'retailers', to: 'store_formats', label: 'retailerId' },
    { from: 'retailers', to: 'stores', label: 'retailerId' },
    { from: 'store_formats', to: 'stores', label: 'formatId' },
    { from: 'campaign_types', to: 'campaigns', label: 'typeId' },
    { from: 'campaign_statuses', to: 'campaigns', label: 'statusId' },
    { from: 'campaigns', to: 'assignments', label: 'campaignId' },
    { from: 'stores', to: 'assignments', label: 'storeId' },
    { from: 'users', to: 'assignments', label: 'operatorId' },
    { from: 'assignments', to: 'proofs', label: 'assignmentId' },
    { from: 'assignments', to: 'issues', label: 'assignmentId' },
    { from: 'retailers', to: 'booking_cycles', label: 'retailerId' },
    { from: 'retailers', to: 'packs', label: 'retailerId' },
    { from: 'tasks', to: 'operator_task_rates', label: 'taskId' },
    { from: 'users', to: 'operator_task_rates', label: 'operatorId' },
    { from: 'users', to: 'payment_records', label: 'operatorId' },
    { from: 'campaigns', to: 'campaign_retailers', label: 'campaignId' },
    { from: 'retailers', to: 'campaign_retailers', label: 'retailerId' },
    { from: 'campaigns', to: 'campaign_stores', label: 'campaignId' },
    { from: 'stores', to: 'campaign_stores', label: 'storeId' },
    { from: 'campaigns', to: 'campaign_media', label: 'campaignId' },
    { from: 'media_formats', to: 'campaign_media', label: 'mediaFormatId' }
  ];

  return (
    <div className="w-full h-screen bg-gray-50 overflow-auto">
      <div className="p-6">
        <h1 className="text-3xl font-bold mb-6 text-center">Database Schema Diagram</h1>
        
        <div className="relative" style={{ width: '1600px', height: '1200px' }}>
          {/* Render connection lines */}
          <svg className="absolute inset-0 w-full h-full pointer-events-none" style={{ zIndex: 1 }}>
            {relationships.map((rel, index) => {
              const fromTable = tables.find(t => t.name === rel.from);
              const toTable = tables.find(t => t.name === rel.to);
              
              if (!fromTable || !toTable) return null;
              
              const fromX = fromTable.position.x + 125; // Center of table
              const fromY = fromTable.position.y + 100;
              const toX = toTable.position.x + 125;
              const toY = toTable.position.y + 100;
              
              return (
                <line
                  key={index}
                  x1={fromX}
                  y1={fromY}
                  x2={toX}
                  y2={toY}
                  stroke="#6B7280"
                  strokeWidth="2"
                  strokeDasharray="5,5"
                  opacity="0.6"
                />
              );
            })}
          </svg>

          {/* Render tables */}
          {tables.map((table) => (
            <Card
              key={table.name}
              className="absolute shadow-lg hover:shadow-xl transition-shadow"
              style={{
                left: table.position.x,
                top: table.position.y,
                width: '250px',
                zIndex: 2,
                borderColor: table.color,
                borderWidth: '2px'
              }}
            >
              <CardHeader 
                className="pb-2" 
                style={{ backgroundColor: table.color + '20' }}
              >
                <CardTitle 
                  className="text-sm font-bold"
                  style={{ color: table.color }}
                >
                  {table.name}
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-2">
                <div className="space-y-1">
                  {table.fields.slice(0, 8).map((field, index) => (
                    <div 
                      key={index} 
                      className={`text-xs ${field.includes('(PK)') ? 'font-bold text-blue-600' : field.includes('(FK)') ? 'text-green-600' : 'text-gray-700'}`}
                    >
                      {field}
                    </div>
                  ))}
                  {table.fields.length > 8 && (
                    <div className="text-xs text-gray-500 italic">
                      +{table.fields.length - 8} more fields...
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Legend */}
        <div className="mt-8 bg-white p-4 rounded-lg shadow">
          <h3 className="font-bold mb-4">Legend</h3>
          <div className="grid grid-cols-4 gap-4 text-sm">
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-blue-500 rounded"></div>
              <span>User Management</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-green-500 rounded"></div>
              <span>Store/Retailer Data</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-yellow-500 rounded"></div>
              <span>Campaign Management</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-red-500 rounded"></div>
              <span>Assignment/Proof</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-purple-500 rounded"></div>
              <span>Media Formats</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-cyan-500 rounded"></div>
              <span>Tasks</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-lime-500 rounded"></div>
              <span>Booking Engine</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-orange-500 rounded"></div>
              <span>Pack System</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-pink-500 rounded"></div>
              <span>Rate/Payment</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-teal-500 rounded"></div>
              <span>Payment Records</span>
            </div>
          </div>
          <div className="mt-4 flex items-center gap-4 text-sm">
            <div className="flex items-center gap-2">
              <span className="font-bold text-blue-600">PK</span>
              <span>Primary Key</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="font-bold text-green-600">FK</span>
              <span>Foreign Key</span>
            </div>
            <div className="flex items-center gap-2">
              <svg width="20" height="2" className="opacity-60">
                <line x1="0" y1="1" x2="20" y2="1" stroke="#6B7280" strokeWidth="2" strokeDasharray="5,5" />
              </svg>
              <span>Relationship</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DatabaseSchema;
